import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const base = process.env.PUBLIC_URL || '';

const LEGAL_DOCS = {
  'aviso-legal': {
    pdf: `${base}/legal/aviso-legal.pdf`,
    title: 'Aviso legal',
  },
  'politica-privacidad': {
    pdf: `${base}/legal/politica-privacidad.pdf`,
    title: 'Política de privacidad',
  },
  'politica-cookies': {
    pdf: `${base}/legal/politica-cookies.pdf`,
    title: 'Política de cookies',
  },
};

class LegalPdfPage extends Component {
  componentDidMount() {
    const doc = LEGAL_DOCS[this.props.docKey];
    if (doc) {
      document.title = `${doc.title} - Clínica Veterinaria Los Cuartos`;
    }
  }

  render() {
    const doc = LEGAL_DOCS[this.props.docKey];
    if (!doc) return null;

    return (
      <React.Fragment>
        <div className="headerSpace" />
        <div className="container legal-pdf-page">
          <div className="legal-pdf-toolbar">
            <h1>{doc.title}</h1>
            <div className="legal-pdf-actions">
              <a
                href={doc.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="legal-pdf-btn"
              >
                Abrir en nueva pestaña
              </a>
              <a href={doc.pdf} download className="legal-pdf-btn legal-pdf-btn--outline">
                Descargar PDF
              </a>
              <Link to="/" className="legal-pdf-btn legal-pdf-btn--ghost">
                Volver al inicio
              </Link>
            </div>
          </div>
          <object
            className="legal-pdf-viewer"
            data={`${doc.pdf}#view=FitH`}
            type="application/pdf"
            title={doc.title}
          >
            <p className="legal-pdf-fallback">
              Su navegador no puede mostrar el PDF integrado.{' '}
              <a href={doc.pdf} target="_blank" rel="noopener noreferrer">
                Abra el documento aquí
              </a>{' '}
              o <a href={doc.pdf} download>descárguelo</a>.
            </p>
          </object>
        </div>
      </React.Fragment>
    );
  }
}

export default LegalPdfPage;

